import styled from 'styled-components'

interface MenuPositionProps {
  $top: number
  $left: number
}

export const MenuTrigger = styled.button`
  background: transparent;
  border: none;
  cursor: pointer;
  padding: 8px;
  border-radius: 50%;
  display: inline-flex;
  align-items: center;
  justify-content: center;

  &:hover {
    background-color: #f5f5f5;
  }
`

export const MenuTriggerIcon = styled.img`
  width: 16px;
  height: 16px;
  opacity: 0.7;
`

export const MenuLayer = styled.div<MenuPositionProps>`
  position: fixed;
  top: ${({ $top }) => `${$top}px`};
  left: ${({ $left }) => `${$left}px`};
  display: flex;
  flex-direction: row;
  align-items: flex-start;
  gap: 4px;
  z-index: 2147483647;
`

export const MenuPanel = styled.div`
  background-color: #fff;
  border: 1px solid #e5e5e5;
  border-radius: 8px;
  box-shadow: 0px 4px 12px rgba(0, 0, 0, 0.1);
  min-width: 200px;
  padding: 8px 0;
`

export const MenuItem = styled.div<{ $active?: boolean; $disabled?: boolean }>`
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 10px 16px;
  cursor: ${({ $disabled }) => ($disabled ? 'not-allowed' : 'pointer')};
  opacity: ${({ $disabled }) => ($disabled ? 0.45 : 1)};
  font-family: 'Inter', sans-serif;
  font-size: 14px;
  color: #303030;
  background-color: ${({ $active }) => ($active ? '#f5f5f5' : 'transparent')};

  &:hover {
    background-color: ${({ $disabled }) => ($disabled ? 'transparent' : '#f5f5f5')};
  }

  svg {
    color: #666666;
    flex-shrink: 0;
  }
`

export const SubMenu = styled.div`
  background-color: #fff;
  border: 1px solid #e5e5e5;
  border-radius: 8px;
  box-shadow: 0px 4px 12px rgba(0, 0, 0, 0.1);
  min-width: 190px;
  padding: 4px 0;
`

export const SubMenuItem = styled.div<{ $disabled?: boolean }>`
  display: flex;
  align-items: center;
  padding: 8px 16px;
  cursor: ${({ $disabled }) => ($disabled ? 'default' : 'pointer')};
  opacity: ${({ $disabled }) => ($disabled ? 0.45 : 1)};

  &:hover {
    background-color: ${({ $disabled }) => ($disabled ? 'transparent' : '#f5f5f5')};
  }
`
